import React, { Component } from 'react';
import { withRouter } from 'react-router'
import Constants from './Constants.js';
import $ from 'jquery';

class CumulativeSignupsByMonth extends Component {

  constructor(props) {
    super(props);
    this.state = {
      studentdata: []
    };
  }

  componentWillMount() {
    const self = this;

    $.ajax({
      type: 'GET',
      url: `${Constants.API_HOST}metrics/cumulative_users_by_month/`,
      contentType: 'application/json',
      dataType: "json",
      xhrFields: { withCredentials:true },
      success: function success(data) {
        self.setState({
          'studentdata': data
        })

      },
      error: function error(data) {

      }
    });

  }

  render() {
    return (
      <div>
        <h1>Cumulative Signups By Month</h1>

        <table className="table">
          <thead>
            <tr>
              <th>
                Month
              </th>
              <th>
                Total Signups
              </th>
            </tr>
          </thead>
          <tbody>
          {
            this.state.studentdata.map(function(sdata) {
              return (
                <tr key={sdata.month+'/'+sdata.year}>
                  <td>
                    {sdata.month+'/'+sdata.year}
                  </td>
                  <td>
                    {sdata.total}
                  </td>
                </tr>
              )
            })
          }
          </tbody>

        </table>

      </div>
    );
  }
}

export default withRouter(CumulativeSignupsByMonth);



// WEBPACK FOOTER //
// ./src/components/CumulativeSignupsByMonth.js